import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ScreenNotificationDefault, Footer, InputText} from '../../components';

import {RouteKeys} from '../../constants';
import {ValidationService, StringService} from '../../services';
import validationBrazilian from './validationBrazilian';
import validationForeign from './validationForeign';
import {
  redirectToDataRegistration,
  redirectToDataContact,
  redirectToDataDocument,
} from '../../ducks/Navigate';
import {
  updateNaturalidade,
  updateDadosPessoais,
  dadosPessoaisAdicionar,
  updateDadosDocumento,
} from '../../ducks/Customer';
import {estadoCivilBuscar, ufBuscar, cidadesBuscar} from '../../ducks/Select';

import Select from 'react-select';
import {SelectStyles} from '../../constants';

import './styles.scss';

class EndDataRegistration extends Component {
  async componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.EndDataRegistration.title,
    );
    this.props.estadoCivilBuscar();
    this.props.ufBuscar();
    this.props.cidadesBuscar();
  }

  handleSubmit = (event) => {
    event.preventDefault();

    if (
      this.props.dadosPessoais.nacionalidade === '' ||
      this.props.dadosPessoais.nacionalidade === 'Brasileira'
    ) {
      if (
        !ValidationService.validate(
          {...this.props.naturalidade, ...this.props.dadosPessoais},
          validationBrazilian,
        )
      )
        return;
    } else {
      if (
        !ValidationService.validate(
          {...this.props.naturalidade, ...this.props.dadosPessoais},
          validationForeign,
        )
      )
        return;

      this.props.naturalidade.uf = '';
      this.props.naturalidade.cidade = '';
    }

    let chave = this.props.chave;
    const {cidade, uf} = this.props.naturalidade;
    this.props.dadosPessoaisAdicionar({
      chave,
      cidade,
      uf,
      ...this.props.dadosPessoais,
    });
  };

  handleChange = (prop, value) => {
    this.props.updateDadosPessoais({prop, value});
  };

  handleChangeNaturalidade = (prop, value) => {
    this.props.updateNaturalidade({prop, value});
  };

  filterName = (value) => {
    return value.toUpperCase();
  };

  selectCityOptions = (cidades, uf) => {
    return uf
      ? cidades
          .filter((cidade) => cidade.uf === uf)
          .map((cidade) => ({
            label: cidade.nome,
            value: cidade.nome,
          }))
      : null;
  };

  render() {
    const isBrazilian =
      this.props.dadosPessoais.nacionalidade === '' ||
      this.props.dadosPessoais.nacionalidade === 'Brasileira';
    const style = isBrazilian ? {} : {display: 'none'};

    return (
      <ScreenNotificationDefault
        title={<p>Queremos te conhecer melhor</p>}
        contentCustom={
          <form className="form" id="frm" onSubmit={this.handleSubmit}>
            <div className="form-group">
              <label htmlFor="nacionalidade" className="form-label">
                Nacionalidade
              </label>

              <Select
                className="select-input"
                isSearchable={true}
                isClearable={true}
                id="nacionalidade"
                name="nacionalidade"
                styles={SelectStyles}
                noOptionsMessage={() => 'Nenhuma opção encontrada'}
                placeholder="Selecione..."
                value={
                  this.props.dadosPessoais.nacionalidade
                    ? {
                        label: this.props.dadosPessoais.nacionalidade,
                        value: this.props.dadosPessoais.nacionalidade,
                      }
                    : ''
                }
                onChange={(ev) => {
                  this.handleChange('nacionalidade', ev ? ev.value : '');

                  let orgaoExpedidor =
                    ev && ev.value === 'Brasileira' ? 'SSP' : 'DPF';
                  this.props.updateDadosDocumento({
                    prop: 'orgaoExpedidor',
                    value: orgaoExpedidor,
                  });
                  this.props.updateDadosDocumento({
                    prop: 'numero',
                    value: '',
                  });
                }}
                options={[
                  {
                    label: 'Brasileira',
                    value: 'Brasileira',
                  },
                  {
                    label: 'Estrangeira',
                    value: 'Estrangeira',
                  },
                ]}
              />
            </div>
            <div className="form-group" style={style}>
              <label htmlFor="uf" className="form-label">
                Estado de Nascimento
              </label>

              <Select
                className="select-input"
                isSearchable={true}
                isClearable={true}
                id="uf"
                name="uf"
                required={isBrazilian}
                styles={SelectStyles}
                noOptionsMessage={() => 'Nenhuma opção encontrada'}
                placeholder="Selecione..."
                value={
                  this.props.naturalidade.uf
                    ? {
                        label: this.props.naturalidade.uf,
                        value: this.props.naturalidade.uf,
                      }
                    : ''
                }
                onChange={(ev) => {
                  this.handleChangeNaturalidade('uf', ev ? ev.value : null);
                  this.handleChangeNaturalidade('cidade', '');
                }}
                options={
                  this.props.ufs &&
                  this.props.ufs.map((uf, indice) => ({
                    label: uf.nome,
                    value: uf.nome,
                    key: indice,
                  }))
                }
              />
            </div>

            <div className="form-group" style={style}>
              <label htmlFor="cidade" className="form-label">
                Cidade de Nascimento
              </label>

              <Select
                className="select-input"
                isSearchable={true}
                isClearable={true}
                isDisabled={this.props.naturalidade.uf ? false : true}
                id="cidade"
                name="cidade"
                required={isBrazilian}
                styles={SelectStyles}
                noOptionsMessage={() => 'Nenhuma opção encontrada'}
                placeholder="Selecione..."
                value={
                  this.props.naturalidade.cidade
                    ? {
                        label: this.props.naturalidade.cidade,
                        value: this.props.naturalidade.cidade,
                      }
                    : ''
                }
                onChange={(ev) =>
                  this.handleChangeNaturalidade('cidade', ev ? ev.value : '')
                }
                options={this.selectCityOptions(
                  this.props.cidades,
                  this.props.naturalidade.uf,
                )}
              />
            </div>

            <div className="form-group">
              <label htmlFor="estadoCivil" className="form-label">
                Estado Civil
              </label>

              <Select
                className="select-input"
                isSearchable={true}
                isClearable={true}
                id="estadoCivil"
                name="estadoCivil"
                required
                styles={SelectStyles}
                noOptionsMessage={() => 'Nenhuma opção encontrada'}
                placeholder="Selecione..."
                value={
                  this.props.dadosPessoais.estadoCivil
                    ? {
                        label: this.props.dadosPessoais.estadoCivil,
                        value: this.props.dadosPessoais.estadoCivil,
                      }
                    : ''
                }
                onChange={(ev) =>
                  this.handleChange('estadoCivil', ev ? ev.value : '')
                }
                options={
                  this.props.estadosCivis &&
                  this.props.estadosCivis.map((estado, indice) => ({
                    label: estado.nome,
                    value: estado.nome,
                    key: indice,
                  }))
                }
              />
            </div>

            <InputText
              id="nomeDaMae"
              name="nomeDaMae"
              maxLength="100"
              placeholder="Nome completo da sua mãe"
              value={this.props.dadosPessoais.nomeDaMae.toUpperCase()}
              onChange={(ev) =>
                this.handleChange('nomeDaMae', this.filterName(ev.target.value))
              }
            />
          </form>
        }
        contentButtons={
          <div className="div-data-contact">
            <Footer hideBtnBack={true} nextForm="frm" />{' '}
          </div>
        }
      />
    );
  }
}

const mapStateToProps = ({customer, select}) => {
  const {chave, naturalidade, dadosPessoais} = customer;
  const {estadosCivis, ufs, cidades} = select;

  return {chave, naturalidade, dadosPessoais, estadosCivis, ufs, cidades};
};

export default connect(mapStateToProps, {
  redirectToDataRegistration,
  redirectToDataContact,
  redirectToDataDocument,
  updateDadosPessoais,
  updateNaturalidade,
  dadosPessoaisAdicionar,
  estadoCivilBuscar,
  ufBuscar,
  cidadesBuscar,
  updateDadosDocumento,
})(EndDataRegistration);
